// extracted by mini-css-extract-plugin
export var label = "_cp-5";
export var slideContainer = "_cp-0";
export var slider = "_cp-1";
export var sliderLg = "_cp-4";
export var sliderMd = "_cp-3";
export var sliderSm = "_cp-2";